import MDTypography from "components/MDTypography";
import React from "react";

function SigninText({ isMobile }) {
  return (
    <MDTypography
      fontSize="32px"
      fontWeight="regular"
      sx={{
        color: isMobile ? "#fff !important" : "#282828",
      }}
    >
      Sign in
    </MDTypography>
  );
}

export default SigninText;
